import { DishOptionTitle } from "./DishOptionTitle";

export default DishOptionTitle;
